export const parseBody = body => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(body, 'text/html');
  return doc.body.innerHTML;
};

export const applyFilters = (insights, filters) => {
  return insights;
};
